import {
  AppBar,
  Box,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Toolbar,
} from "@mui/material";
import { useEffect, useState, useContext, useRef } from "react";
import {
  linear_content_style,
  linear_h,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import TabPage from "../../components/TabPage";
import { R } from "../../R";
import MoreIcon from "@mui/icons-material/MoreVert";
import Title from "../../../libs/rhf-mui/ui/Title";
import { useLocation } from "react-router-dom";
import { useCommonQuest } from "./useCommonQuest";
import { UniForm } from "../../dao/UniForm";
import { UniAnswer } from "../../dao/UniAnswer";
import { useAppContext } from "../../../libs/app-core/AppContext";
import UcQuestionPanel from "../../components/uni/UcQuestionPanel";
import { UniQuestion } from "../../dao/UniQuestion";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import { FormProvider, useForm } from "react-hook-form";
import UcDevTools from "./UcDevTools";
import { Toast } from "../../../libs/app-core/Toast";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import { DialogButtons } from "../../../libs/app-core/dialogs/DialogButtons";
import { CommonQuest_YupSchemaBuilder } from "./CommonQuest_YupSchemaBuilder";
import { ValueChangedListener } from "../FrmSpwkQuestionnaire/ValueChangedListener";
import { UiMetaTable, UiMetaTableContext } from "../FrmSpwkQuestV3/UiMetaTable";
import { 清空連動後看不到的選項 } from "../FrmSpwkQuestionnaire";
import dayjs from "dayjs";
import { GVContext } from "../../GV";
import { UcHumanBodyImage_RHF_NAME_List } from "../../components/uni/UcHumanBodyImage";
import { Member } from "../../dao/Member";
import { useMember } from "../../dao/MemberDAO";
import MemberNavbar from "../../components/MemberNavbar";
import { useTranslation } from "react-i18next";

/** 此頁面的輸入參數(預計透過url控制) */
export type FrmCommonQuestProps = {
  answer_guid?: string;
};

type Props = {};

const FrmCommonQuest = (props: Props) => {
  const ctx = useAppContext();
  const GV = useContext(GVContext);
  //#region 讀取網址參數
  let params = useLocation().state;
  let answer_guid = params.answer_guid ?? undefined;
  //#endregion

  //---------------------------------------------------------------

  /* 核心變數: 此 Answer 與其通用問題 + 特作版本列表 */
  let { _UniAnswer, _UniAnswerRef, _CommonForm, _CommonFormRef } =
    useCommonQuest(answer_guid); // $$$

  const [LangA, set_LangA] = useState<Lang>("CHI"); // 主要語言
  const [LangB, set_LangB] = useState<Lang>(""); // 次要語言

  const [IsSkipValid, set_IsSkipValid] = useState(false); // 跳過數值驗證
  const IsSkipValidRef = useRef(IsSkipValid);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const MAX_WIDTH = "md";
  const [AppBarTabIndex, set_AppBarTabIndex] = useState("Tab1");

  const { t } = useTranslation();

  /** 取得原始數值(rhf.reset()時同時記憶未修改前的數值) */
  const [OriRhfData, set_OriRhfData] = useState<any>(undefined);
  let guid: string | undefined = undefined;
  if (_UniAnswer?.member_guid !== undefined) {
    guid = _UniAnswer?.member_guid;
  }
  const { _Member } = useMember(guid);
  const [member, setMember] = useState<Member | undefined>(undefined);

  const BLANK_YUP_SCHEMA = yup.object().shape({});
  let [YupSchema, set_YupSchema] = useState<any>(BLANK_YUP_SCHEMA);
  /** react-hook-form */
  const rhf = useForm<any>({
    resolver: yupResolver(YupSchema),
  });

  const [_UiMetaTable, set_UiMetaTable] = useState<UiMetaTable | undefined>(
    undefined
  );
  useEffect(() => {
    // 監聽 _Member 的變化，並更新 member 的值
    if (_Member !== undefined && _Member !== null) {
      setMember(_Member);
    }
  }, [_Member]);
  useEffect(() => {
    /** Init UiMetaTable - 準備好一張UI大表，方便 OnRhfValueChanged() 時，連動改變其他元件 */

    if (_CommonForm != null) {
      let meta_table = new UiMetaTable();

      let chapters: string[] = [];
      if (_CommonForm.AllQuestions != null) {
        chapters = chapters.concat(
          _CommonForm.AllQuestions.map((x) => x.chapter)
        );
      }

      chapters = chapters.filter(
        (value, index, array) => array.indexOf(value) === index
      ); // 不重複的

      for (const chapter of chapters) {
        let questions: UniQuestion[] = SpwkUtil.GetChapterQuestionsV3(
          chapter,
          _CommonForm,
          []
        );

        let meta_list = UiMetaTable.ConvertQuestionToMetaList(questions);

        meta_table.ConcatMetaList(meta_list);
      }

      set_UiMetaTable(meta_table);
    }
  }, [_CommonForm]);

  useEffect(() => {
    // Init: 讀取檔案 Answer
    if (_UniAnswer == null) {
      return; //查無資料
    }

    if (_UniAnswer === undefined || _CommonForm === undefined) {
      return; // 還沒撈資料
    }

    const yup_schema = CreactYupSchma();
    set_YupSchema(yup_schema);

    let rhf_data = _UniAnswer.ConvertToCommonRhfData();

    rhf.reset(rhf_data); // 讀檔。 將數值填入 rhf

    let ori_data = _UniAnswer.ConvertToCommonRhfData(); // 在此重新產生最原始沒有被修改過的rhf資料
    set_OriRhfData(ori_data);
  }, [
    _CommonForm,
    _UniAnswer == null
      ? null
      : _UniAnswer === undefined
      ? undefined
      : _UniAnswer.guid,
  ]);

  function Is跳過不觸發Watch(rhf_name: string | undefined) {
    if (rhf_name == null) {
      return false;
    }
    if (UcHumanBodyImage_RHF_NAME_List.includes(rhf_name)) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    // $$$ Watch - OnRhfValueChanged()、OnValueChanged() 監聽數值改變時連動其他數值的部分
    const subscription = rhf.watch((value, { name, type }) => {
      if (IsSkipValid) {
        // pass;
      } else {
        let yup = CreactYupSchma();
        set_YupSchema(yup);
      }

      if (Is跳過不觸發Watch(name)) {
        return;
      } else {
      }

      ValueChangedListener.OnWatch(ctx, _UiMetaTable, rhf, value, name, type);
    });

    return () => {
      subscription.unsubscribe();
      return;
    };
  }, [rhf.watch, _UiMetaTable]); // 這裡放 _UiMetaTable 可能是錯的

  //#region Blocker: 出現例外狀況
  if (_UniAnswer === null) {
    ctx.NavigateToErrorPage("", "Answer 查無資料!", "");
    return <>ERROR!</>;
  }

  if (_CommonForm === null) {
    ctx.NavigateToErrorPage("", "查無特作共用問題!!", "");
    return <>ERROR!</>;
  }
  //#endregion

  //#region Blocker: 變數尚未準備好
  if (_UniAnswer == null || _CommonForm == null) {
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題
    return <></>;
  }

  if (member == null || member == undefined) {
    //2024-03-18  YAO 暫時拔除Loading...以解決翻譯問題
    return <></>;
  }
  //#endregion

  /** 繪製一般問卷 */
  function render_CommonQuest(
    _CommonForm: UniForm,
    _UniAnswer: UniAnswer,
    member: Member
  ) {
    let questions: UniQuestion[] = _CommonForm.AllQuestions ?? [];

    return (
      <Box sx={{ bgcolor: R.color.paper }}>
        <Container maxWidth={MAX_WIDTH} sx={{ height: "100%", pt: 3, pb: 3 }}>
          <UiMetaTableContext.Provider
            value={{ _UiMetaTable, OriRhfData, member }}
          >
            <FormProvider {...rhf}>
              {/* DebugTools */}
              {GV?.IsAdmin() === true ? (
                <UcDevTools
                  _UniAnswer={_UniAnswer}
                  _UniCommonForm={_CommonForm}
                  LangA={LangA}
                  set_LangA={set_LangA}
                  LangB={LangB}
                  set_LangB={set_LangB}
                  IsSkipValid={IsSkipValid}
                  set_IsSkipValid={set_IsSkipValid}
                  OnSkipValidChanged={(check: boolean) => {
                    IsSkipValidRef.current = check;
                    const yup_schema = CreactYupSchma();
                    set_YupSchema(yup_schema);
                  }}
                />
              ) : undefined}
              <form
                onSubmit={rhf.handleSubmit(
                  (data: any, event: any) => {
                    SaveData(data, event);
                  },
                  (errors: any, event: any) => {
                    OnInvalid(errors, event);
                  }
                )}
              >
                <Card sx={{ px: 3, mt: 2 }}>
                  <Grid container sx={{ pb: 20 }}>
                    <UcQuestionPanel
                      questions={questions}
                      member={member}
                      LangA={LangA}
                      LangB={LangB}
                    />
                    <div />
                    <div />
                    <div />
                    <Grid item xs={12} p={2} pt={4}>
                      <Button
                        type="submit"
                        disabled={isSubmitting === true}
                        size="medium"
                        variant="contained"
                        color="primary"
                        sx={{ py: 1.5, px: 2 }}
                      >
                        <Title variant="subtitle2">{t("完成送出")}</Title>
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </form>
            </FormProvider>
          </UiMetaTableContext.Provider>
        </Container>
      </Box>
    );
  }

  return (
    <Box style={linear_content_style}>
      {/* 外框架 */}
      <Grid {...linear_h}>
        <Grid {...linear_item} width={0} bgcolor="#FFCCFF">
          {/* 左側主檔 Master */}
          <Box bgcolor="#CCCCFF"></Box>
        </Grid>
        <Grid {...linear_item} flex={1} bgcolor="">
          {/* 中間列表 Details */}
          {render_Detail(_CommonForm, _UniAnswer, member)}
        </Grid>
      </Grid>
    </Box>
  );

  function render_Detail(
    _CommonForm: UniForm,
    _UniAnswer: UniAnswer,
    member: Member
  ) {
    return (
      <>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_AppBar()}</Grid>
          <Grid {...linear_item} flex={1}>
            <Box style={linear_content_style} sx={{}}>
              <TabPage tab_key={"Tab1"} curr_tab={AppBarTabIndex} sx={{}}>
                {render_CommonQuest(_CommonForm, _UniAnswer, member)}
              </TabPage>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position="static" sx={{ bgcolor: R.color.app_bar }}>
          <Toolbar variant="dense">
            {render_AppTitle()}
            <Box sx={{ flexGrow: 1 }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
            {/* {render_ActionButtons()} */}
            <MemberNavbar />
          </Toolbar>
          {/* {render_AppTabs()} */}
        </AppBar>
      </>
    );
  }

  function render_AppTitle() {
    return (
      <Title variant="subtitle2">{t(_CommonForm?.form_title ?? "")}</Title>
    );
  }

  function render_ActionButtons() {
    return (
      <div>
        <IconButton
          children={<MoreIcon />}
          size="large"
          aria-label="search"
          color="inherit"
        />
      </div>
    );
  }

  function CreactYupSchma() {
    if (IsSkipValidRef.current) {
      // 不使用YUP驗證，方便開發測試
      Toast.ShowDanger(ctx, "[DEBUG] 略過驗證");
      return BLANK_YUP_SCHEMA;
    }

    if (
      _UniAnswerRef.current === undefined ||
      _CommonFormRef.current === undefined
    ) {
      return BLANK_YUP_SCHEMA;
    }

    if (_CommonFormRef.current == null) {
      throw new_ErrorAlert("49416516 _CommonForm==null !!!");
    }

    const yup_schema = CommonQuest_YupSchemaBuilder.CreateSchema(
      rhf,
      _CommonFormRef.current
    );
    return yup_schema;
  }

  async function SaveData(data: any, event: any) {
    if (isSubmitting) {
      return; // 防止重複提交
    }

    setIsSubmitting(true);

    try {
      if (_UiMetaTable == null) {
        throw new_ErrorAlert("64643164 _UiMetaTable==null !!!");
      }

      清空連動後看不到的選項(rhf, _UiMetaTable, data);

      data = SpwkUtil.僅保留有Data中有輸入的數值(data);

      MessageDialog.Show(ctx, "", t("確定送出?"), {
        ...DialogButtons.OKCancel,
        async onDialogResult(e) {
          if (e.DialogResult === "Yes") {
            if (_UniAnswer == null) {
              alert("_UniAnswer==null");
              return;
            }

            _UniAnswer.SetValueByCommonRhfData(_UniAnswer.member_guid, data);
            await UniAnswerDAO.WS_Update(_UniAnswer);
            if (dayjs(_UniAnswer.rec_dt).year() === 2999) {
              await UniAnswerDAO.WS_Update_完成問卷時間(_UniAnswer);
            }
            setIsSubmitting(false);
            Toast.ShowScuccess(ctx, t("儲存成功"));
            window.history.back();
          } else {
            Toast.Show(ctx, t("取消存檔"));
          }
        },
      });
    } catch {
      MessageDialog.Show(ctx, "", t("儲存失敗"), {
        ...DialogButtons.Error,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  function OnInvalid(errors: any, event: any) {
    MessageDialog.Show(ctx, t("可能有遺漏或格式不符!"), t("儲存失敗"), {
      colorMeaning: "Warning",
      onDialogResult(e) {
        Toast.ShowWarning(ctx, t("請修正"));
        scroll_to_error_message(errors, event);
      },
    });
  }

  function scroll_to_error_message(errors: any, event: any) {
    const timer = setTimeout(() => {
      //錯誤訊息的元素 ClassName 是 .Mui-error
      const error_message = document.querySelector(".Mui-error");
      if (!error_message) {
        return;
      }

      error_message.scrollIntoView({ block: "center" });
    }, 500);
  }

  /*
* 這裡預計取得全表例外驗證後的錯誤訊息
* 目前只對 章節內的 input 有效
* 如果要單選 或 多選，要再補上

* YupSchemaBuilder.YupGlobalValidation() 產出的驗證
*/
};

export default FrmCommonQuest;
